import _defineProperty from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useMutation } from "@apollo/client";
import { AddItemToWishListDocument, RemoveItemFromWishListDocument } from "@catchoftheday/common-vendors";
import { dispatchEventBus } from "@catchoftheday/state";
import { createToast, updateToast } from "@catchoftheday/toast";
import { GENERIC_ERROR, UNABLE_TO_ADD_TO_CART, UNABLE_TO_ADD_TO_WISHLIST, UNABLE_TO_REMOVE_FROM_WISHLIST, UNABLE_TO_REMOVE_ITEM } from "../consts";
import { AddItemsToCartDocument, AddToCartDocument, MoveItemFromCartToWishlistDocument, RemoveItemFromCartDocument } from "../generated/graphql";
export var MutationType;

(function (MutationType) {
  MutationType["ADD_TO_CART"] = "addToCart";
  MutationType["ADD_ITEMS_TO_CART"] = "addItemsToCart";
  MutationType["REMOVE_ITEM_FROM_CART"] = "removeItemFromCart";
  MutationType["MOVE_ITEM_FROM_CART_TO_WISHLIST"] = "moveItemFromCartToWishlist";
  MutationType["ADD_TO_WISHLIST"] = "addItemToWishlist";
  MutationType["ADD_TO_NOTIFY_WISHLIST"] = "addItemToNotifyWishlist";
  MutationType["REMOVE_FROM_NOTIFY_WISHLIST"] = "removeItemFromNotifyWishlist";
  MutationType["REMOVE_FROM_WISHLIST"] = "removeItemFromWishlist";
})(MutationType || (MutationType = {}));

var toastConfig = {
  addToCart: {
    mutationDocumentNode: AddToCartDocument,
    showCheckoutOnSuccess: true,
    eventBusMessageType: "@cart-app/ADD_TO_CART",
    messages: {
      loading: "Adding...",
      success: "Added!",
      error: UNABLE_TO_ADD_TO_CART
    }
  },
  addItemsToCart: {
    mutationDocumentNode: AddItemsToCartDocument,
    showCheckoutOnSuccess: true,
    eventBusMessageType: "@cart-app/ADD_TO_CART",
    messages: {
      loading: "Adding...",
      success: "Added!",
      error: UNABLE_TO_ADD_TO_CART
    }
  },
  removeItemFromCart: {
    mutationDocumentNode: RemoveItemFromCartDocument,
    showTickOnSuccess: true,
    eventBusMessageType: "@cart-app/REMOVE_ITEM_FROM_CART",
    messages: {
      loading: "Removing...",
      success: "Item removed from cart.",
      error: UNABLE_TO_REMOVE_ITEM
    }
  },
  moveItemFromCartToWishlist: {
    mutationDocumentNode: MoveItemFromCartToWishlistDocument,
    showTickOnSuccess: true,
    eventBusMessageType: "@cart-app/ADD_TO_WISHLIST",
    messages: {
      loading: "Adding to wishlist...",
      success: "Added to wishlist!",
      error: UNABLE_TO_ADD_TO_WISHLIST
    }
  },
  addItemToWishlist: {
    mutationDocumentNode: AddItemToWishListDocument,
    showTickOnSuccess: true,
    eventBusMessageType: "@cart-app/ADD_TO_WISHLIST",
    messages: {
      loading: "Adding to wishlist...",
      success: "Added to wishlist!",
      error: UNABLE_TO_ADD_TO_WISHLIST
    }
  },
  addItemToNotifyWishlist: {
    fieldName: "addItemToWishlist",
    mutationDocumentNode: AddItemToWishListDocument,
    showTickOnSuccess: true,
    eventBusMessageType: "@cart-app/ADD_TO_WISHLIST",
    messages: {
      loading: "Adding to notify list...",
      success: "Added to Notify list! You will receive an email when this item is back in stock",
      error: UNABLE_TO_ADD_TO_WISHLIST,
      tertiary: true
    }
  },
  removeItemFromNotifyWishlist: {
    fieldName: "addItemToWishlist",
    mutationDocumentNode: AddItemToWishListDocument,
    showTickOnSuccess: true,
    eventBusMessageType: "@cart-app/REMOVE_FROM_WISHLIST",
    messages: {
      loading: "Removing from notify list...",
      success: "Removed from Notify list! You will not be notified when this item is back in stock",
      error: UNABLE_TO_ADD_TO_WISHLIST,
      tertiary: true
    }
  },
  removeItemFromWishlist: {
    mutationDocumentNode: RemoveItemFromWishListDocument,
    showTickOnSuccess: true,
    eventBusMessageType: "@cart-app/REMOVE_FROM_WISHLIST",
    messages: {
      loading: "Removing from wishlist...",
      success: "Removed from wishlist!",
      error: UNABLE_TO_REMOVE_FROM_WISHLIST
    }
  }
};

var getResponse = function getResponse(mutationType, data) {
  if (!data) {
    return null;
  }

  return data === null || data === void 0 ? void 0 : data[mutationType];
};

var noop = function noop() {
  return undefined;
};

export var useToast = function useToast(_ref) {
  var mutationType = _ref.mutationType,
      _ref$setError = _ref.setError,
      setError = _ref$setError === void 0 ? noop : _ref$setError,
      _ref$setLoading = _ref.setLoading,
      setLoading = _ref$setLoading === void 0 ? noop : _ref$setLoading,
      showCheckoutOnSuccess = _ref.showCheckoutOnSuccess,
      showTickOnSuccess = _ref.showTickOnSuccess,
      _ref$noToast = _ref.noToast,
      noToast = _ref$noToast === void 0 ? false : _ref$noToast,
      _onCompleted = _ref.onCompleted,
      fetchPolicy = _ref.fetchPolicy,
      refetchQueries = _ref.refetchQueries,
      awaitRefetchQueries = _ref.awaitRefetchQueries;
  var _toastConfig$mutation = toastConfig[mutationType],
      fieldName = _toastConfig$mutation.fieldName,
      mutationDocumentNode = _toastConfig$mutation.mutationDocumentNode,
      defaultShowCheckoutOnSuccess = _toastConfig$mutation.showCheckoutOnSuccess,
      defaultShowTickOnSuccess = _toastConfig$mutation.showTickOnSuccess,
      eventBusMessageType = _toastConfig$mutation.eventBusMessageType,
      _toastConfig$mutation2 = _toastConfig$mutation.messages,
      loadingMessage = _toastConfig$mutation2.loading,
      successMessage = _toastConfig$mutation2.success,
      generalErrorMessage = _toastConfig$mutation2.error,
      tertiary = _toastConfig$mutation2.tertiary;

  function isToastRequired(props) {
    if (!noToast) {
      return updateToast(props);
    }
  }

  function conditionallyCreateToast(props) {
    if (!noToast) {
      return createToast(props);
    }
  }

  var _useMutation = useMutation(mutationDocumentNode, {
    refetchQueries: refetchQueries,
    awaitRefetchQueries: awaitRefetchQueries,
    onCompleted: function onCompleted() {
      if (typeof _onCompleted === "function") {
        _onCompleted();
      }
    },
    fetchPolicy: fetchPolicy
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      mutateFunction = _useMutation2[0];

  var wrappedMutationFunction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _mutationResponse$err,
          response,
          mutationResponse,
          userError,
          batchUserError,
          errorMessage,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              setError(undefined);
              _context.prev = 2;
              _context.next = 5;
              return mutateFunction.apply(void 0, _args);

            case 5:
              response = _context.sent;
              setLoading(false);
              mutationResponse = getResponse(fieldName !== null && fieldName !== void 0 ? fieldName : mutationType, response.data);
              userError = (mutationResponse === null || mutationResponse === void 0 ? void 0 : mutationResponse.__typename) === "UserError" ? mutationResponse.message : undefined;
              batchUserError = (mutationResponse === null || mutationResponse === void 0 ? void 0 : mutationResponse.__typename) === "CartBatchMutationResponse" && mutationResponse.errors.length > 0 && ((_mutationResponse$err = mutationResponse.errors.find(function (error) {
                return error.message;
              })) === null || _mutationResponse$err === void 0 ? void 0 : _mutationResponse$err.message);
              errorMessage = response.errors ? GENERIC_ERROR : userError || batchUserError;

              if (errorMessage) {
                setError(errorMessage);
              }

              return _context.abrupt("return", response);

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](2);
              setError(GENERIC_ERROR);
              setLoading(false);
              throw _context.t0;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 15]]);
    }));

    return function wrappedMutationFunction() {
      return _ref2.apply(this, arguments);
    };
  }();

  var returnMutateFunction = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(items, mutateVariables, mutateContext) {
      var toastItems, toastContent, toastId, _yield$wrappedMutatio, data, _yield$wrappedMutatio2, errors, mutateResponse, _errors;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!Array.isArray(items)) {
                items = [items];
              }

              toastItems = items.map(function (item) {
                return {
                  message: loadingMessage,
                  status: "info",
                  imageUrl: item.imageUrl,
                  title: item.title,
                  showTickOnSuccess: typeof showTickOnSuccess === "boolean" ? showTickOnSuccess : defaultShowTickOnSuccess,
                  offerId: item.offerId
                };
              });
              toastContent = {
                items: toastItems,
                showCheckoutOnSuccess: typeof showCheckoutOnSuccess === "boolean" ? showCheckoutOnSuccess : defaultShowCheckoutOnSuccess
              };
              toastId = conditionallyCreateToast({
                toastContent: toastContent
              });
              _context2.next = 6;
              return wrappedMutationFunction({
                variables: mutateVariables,
                context: mutateContext
              });

            case 6:
              _yield$wrappedMutatio = _context2.sent;
              data = _yield$wrappedMutatio.data;
              _yield$wrappedMutatio2 = _yield$wrappedMutatio.errors;
              errors = _yield$wrappedMutatio2 === void 0 ? [] : _yield$wrappedMutatio2;
              mutateResponse = getResponse(fieldName !== null && fieldName !== void 0 ? fieldName : mutationType, data);

              if (!(errors.length > 0)) {
                _context2.next = 14;
                break;
              }

              isToastRequired({
                toastId: toastId,
                toastContent: _objectSpread(_objectSpread({}, toastContent), {}, {
                  items: toastItems.map(function (toastItem) {
                    return _objectSpread(_objectSpread({}, toastItem), {}, {
                      message: generalErrorMessage,
                      status: "error"
                    });
                  })
                })
              });
              return _context2.abrupt("return", {
                status: "ServerError"
              });

            case 14:
              if (!((mutateResponse === null || mutateResponse === void 0 ? void 0 : mutateResponse.__typename) === "UserError")) {
                _context2.next = 17;
                break;
              }

              isToastRequired({
                toastId: toastId,
                toastContent: _objectSpread(_objectSpread({}, toastContent), {}, {
                  items: toastItems.map(function (toastItem) {
                    return _objectSpread(_objectSpread({}, toastItem), {}, {
                      message: mutateResponse === null || mutateResponse === void 0 ? void 0 : mutateResponse.message,
                      status: "error"
                    });
                  })
                })
              });
              return _context2.abrupt("return", {
                status: "UserError"
              });

            case 17:
              if ((mutateResponse === null || mutateResponse === void 0 ? void 0 : mutateResponse.__typename) === "Cart" || (mutateResponse === null || mutateResponse === void 0 ? void 0 : mutateResponse.__typename) === "WishlistItem" || (mutateResponse === null || mutateResponse === void 0 ? void 0 : mutateResponse.__typename) === "RemoveFromWishlistItem") {
                isToastRequired({
                  toastId: toastId,
                  toastContent: _objectSpread(_objectSpread({}, toastContent), {}, {
                    items: toastItems.map(function (toastItem) {
                      return _objectSpread(_objectSpread({}, toastItem), {}, {
                        message: successMessage,
                        status: tertiary ? "tertiary" : "success"
                      });
                    })
                  })
                });

                if (eventBusMessageType) {
                  dispatchEventBus({
                    type: eventBusMessageType
                  });
                }
              }

              if (!((mutateResponse === null || mutateResponse === void 0 ? void 0 : mutateResponse.__typename) === "CartBatchMutationResponse")) {
                _context2.next = 24;
                break;
              }

              _errors = mutateResponse.errors;
              isToastRequired({
                toastId: toastId,
                toastContent: _objectSpread(_objectSpread({}, toastContent), {}, {
                  items: toastItems.map(function (toastItem) {
                    var message = successMessage;
                    var status = "success";

                    var errorItem = _errors.find(function (error) {
                      return error.offerId == toastItem.offerId;
                    });

                    if (errorItem) {
                      message = errorItem.message;
                      status = "error";
                    }

                    return _objectSpread(_objectSpread({}, toastItem), {}, {
                      message: message,
                      status: status
                    });
                  })
                })
              });

              if (eventBusMessageType) {
                dispatchEventBus({
                  type: eventBusMessageType
                });
              }

              if (!_errors.length) {
                _context2.next = 24;
                break;
              }

              return _context2.abrupt("return", {
                status: _errors
              });

            case 24:
              return _context2.abrupt("return", {
                status: "OK",
                data: mutateResponse
              });

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function returnMutateFunction(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return returnMutateFunction;
};
export var useAddToCartToast = function useAddToCartToast(props) {
  return useToast(_objectSpread({
    mutationType: MutationType.ADD_TO_CART
  }, props));
};